import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import styled from "styled-components";
import { ErrorText } from "../../../../components/billing";
import { Button, DangerButton } from "../../../../components/button";
import { NumberField } from "../../../../components/forms/number";
import { TextField } from "../../../../components/forms/text";
import { Icon } from "../../../../components/icons";
import { AllowedBlockchains } from "../../../../store/chain/models/internal";
import { FieldSection, SectionTitle } from "../common/components";
import { FormType } from "./common";

const StyledButton = styled(Button)`
  margin-top: 1em;
`;

const RemoveButton = styled(DangerButton)`
  height: 3em;
  width: 3em;
  min-width: auto;
  padding: 0;
  margin-top: 8px; // to be in line with the fields
`;

const Table = styled.table`
  width: 100%;
`;

const Td = styled.td`
  padding: 0.3em 1em;
  vertical-align: top;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;

export const SingleChain: React.FunctionComponent<{
  chain: AllowedBlockchains;
}> = ({ chain }) => {
  const { control, formState, clearErrors } = useFormContext<FormType>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: `${chain}.pledgingInfo`,
  });

  return (
    <FieldSection>
      <SectionTitle>{chain}</SectionTitle>
      <Table>
        <tbody>
          {fields.map(({ id }, index) => (
            <tr key={id}>
              <Td>
                <Controller
                  control={control}
                  name={`${chain}.pledgingInfo.${index}.currency`}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      label="Currency"
                      fullWidth
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </Td>
              <Td>
                <Controller
                  control={control}
                  name={`${chain}.pledgingInfo.${index}.amount.minimum`}
                  render={({ field, fieldState: { error } }) => (
                    <NumberField
                      {...field}
                      fullWidth
                      label="Minimum Amount"
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </Td>
              <Td>
                <Controller
                  control={control}
                  name={`${chain}.pledgingInfo.${index}.amount.maximum`}
                  render={({ field, fieldState: { error } }) => (
                    <NumberField
                      {...field}
                      label="Maximum Amount"
                      fullWidth
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </Td>
              <Td>
                <RemoveButton onClick={() => remove(index)}>
                  <Icon fontSize="medium" type="trash" />
                </RemoveButton>
              </Td>
            </tr>
          ))}
        </tbody>
      </Table>
      {formState.errors?.[chain]?.["pledgingInfo"]?.message ? (
        <ErrorText>
          {formState.errors?.[chain]?.["pledgingInfo"]?.message}
        </ErrorText>
      ) : null}
      <StyledButton
        onClick={() => {
          append({
            decimalPoints: 18,
          } as any);
          clearErrors(chain);
        }}
      >
        Add Currency
      </StyledButton>
    </FieldSection>
  );
};
